import { makeSelectCurrentSnapshot } from 'pages/SnapshotManagement/selectors';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { snapshotSupportsCloudLicensing } from 'utils/pageGating/cloudLicensingPageGating';
import type { ImmutableSnapshot } from './snapshotManagementTypes';

interface SelectorProps {
  snapshot: ImmutableSnapshot;
}

const selector = createStructuredSelector({
  snapshot: makeSelectCurrentSnapshot(),
});

/**
 * Whether the currently selected snapshot supports the new cloud licensing model.
 *
 * `undefined` means there is nothing to tell yet — no snapshot is selected, or the snapshot list
 * has not been loaded.
 *
 * Returns the verdict rather than the `licenseUsage` value itself, both to keep the Immutable
 * structure out of `GlobalState` and to avoid `useCurrentSnapshot`, which converts the whole
 * snapshot with `toJS()` on every change.
 */
export const useCurrentSnapshotCloudLicensing = (): boolean | undefined => {
  const { snapshot } = useSelector<unknown, SelectorProps>(selector);
  if (!snapshot) {
    return undefined;
  }
  return snapshotSupportsCloudLicensing(snapshot.get('licenseUsage'));
};
